<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Serviços</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Serviços</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">{{ labelName }}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(paymentMethod, index) in paymentMethods"
                    :key="index"
                  >
                    <td></td>
                    <td>{{ paymentMethod.Code }}</td>
                    <td>{{ paymentMethod.Name }}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('PaymentMethod', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenPaymentMethod($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('PaymentMethod', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenPaymentMethod($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      paymentMethods == undefined ||
                      paymentMethods == null ||
                      paymentMethods.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormPaymentMethod"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>
      <div v-if="!loadingModal">
        <d-form-row>
          <!-- Code -->
          <d-col md="6" class="form-group">
            <label>Código</label>
            <d-form-input
              type="text"
              v-model="infoPaymentMethod.Code"
              :disabled="true"
            />
          </d-col>
          <!-- Name -->
          <d-col md="6" class="form-group">
            <label>Nome</label>
            <d-form-input
              type="text"
              v-model="infoPaymentMethod.Name"
              :disabled="true"
            />
          </d-col>
        </d-form-row>
        <!-- Description -->
        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Descrição</label>
            <b-form-textarea
              type="text"
              rows="4"
              v-model="infoPaymentMethod.Description"
              :disabled="isSeeing"
            />
          </d-col>
        </d-form-row>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SavePaymentMethod()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            Salvar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "services",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      labelName: "Nome",
      modalTitle: "Detalhes do serviço",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
        TotalAmount: 0,
      },
      filter: {
        Name: null,
      },
      idPaymentMethod: 0,
      paymentMethods: [],
      infoPaymentMethod: {
        Code: null,
        Name: null,
        Description: null,
      },
      isSeeing: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListPaymentMethod();
    },
    "pagination.RowsPerPage": function () {
      this.ListPaymentMethod();
    },
  },
  mounted() {
    this.ListPaymentMethod();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListPaymentMethod();
    },
    OpenPaymentMethod: function (e, i, view) {
      e.preventDefault();
      this.loadingAddUpdate = false;
      this.ResetInfoPaymentMethod();

      if (view == undefined && i != undefined) {
        // Edit
        this.idPaymentMethod = this.paymentMethods[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar serviço";
        this.GetPaymentMethod();
      } else if (view && i != undefined) {
        // View
        this.idPaymentMethod = this.paymentMethods[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do serviço";
        this.GetPaymentMethod();
      }
      this.$bvModal.show("mFormPaymentMethod");
    },
    ResetInfoPaymentMethod: function () {
      this.infoPaymentMethod = {
        Code: null,
        Name: null,
        Description: null,
      };
    },
    SavePaymentMethod: function () {
      this.loadingAddUpdate = true;
      this.isSeeing = true;
      // Update
      this.$store
        .dispatch("UpdatePaymentMethod", this.infoPaymentMethod)
        .then(() => {
          this.$makeToast(
            "Suas modificações foram salvas na base de dados.",
            "success",
            "Serviço"
          );
          this.ListPaymentMethod();
          this.$bvModal.hide("mFormPaymentMethod");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar o serviço",
            error
          );
        })
        .finally(() => {
          this.loadingAddUpdate = false;
          this.isSeeing = false;
        });
    },
    GetPaymentMethod: function () {
      if (this.idPaymentMethod != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetPaymentMethod", { id: this.idPaymentMethod })
          .then((response) => {
            this.infoPaymentMethod = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o serviço",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListPaymentMethod: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListPaymentMethodIsEnabled", { params: data })
        .then((response) => {
          this.paymentMethods = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os serviços",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
      };
      this.ListPaymentMethod();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/services.vue